import { render, staticRenderFns } from "./createMemberOrder.vue?vue&type=template&id=4f97ec3c&scoped=true&"
import script from "./createMemberOrder.vue?vue&type=script&lang=js&"
export * from "./createMemberOrder.vue?vue&type=script&lang=js&"
import style0 from "./createMemberOrder.vue?vue&type=style&index=0&id=4f97ec3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97ec3c",
  null
  
)

export default component.exports